import { Box } from "@rebass/grid";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { formatDate } from "@rentiohq/shared-frontend/dist/utils/date.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Banner, Button, Grid } from "@rentiohq/web-shared/dist/components";
import { useNavigate } from "react-router-dom";

interface IProps {
  linkedContracts: IContract[];
}

export const LinkedPropertyBanner = ({ linkedContracts }: IProps) => {
  const navigate = useNavigate();

  return (
    <Banner
      title={getLocalizedText("contract.linked_property.contract_info.heading")}
      variation="info"
      hasDismiss={false}
    >
      {linkedContracts.map(contract => (
        <Grid key={contract.id} spacing="extraTight">
          <Grid.Item>
            <Box>{getLocalizedText("contract.main_property_info_line_1")}</Box>
          </Grid.Item>
          <Grid.Item>
            <Button
              appearance="link"
              onClick={() => navigate(`/properties/${contract.propertyId}`)}
            >
              {`${contract.propertyAddress?.simple}.`}
            </Button>
          </Grid.Item>
          <Grid.Item>
            <Box>
              {getLocalizedText("contract.main_property_info_line_2", {
                startDate: formatDate(contract.startDate),
                endDate: contract.stopDate ? formatDate(contract.stopDate) : "",
              })}
            </Box>
          </Grid.Item>
        </Grid>
      ))}
    </Banner>
  );
};
